module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.activatedClub) ? _c('div', _vm._l((_vm.clubList), function(club) {
    return _c('div', [(_vm.clubList) ? _c('leagueRankingPanel', {
      attrs: {
        "club": club
      }
    }) : _vm._e()], 1)
  }), 0) : _c('div', [_c('leagueRankingPanel', {
    key: _vm.activatedClub.id,
    attrs: {
      "club": _vm.activatedClub
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149c0824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ranking/ranking.vue
// module id = 711
// module chunks = 0